<template>
  <div class="poster">
    <ul class="posterContentList">
      <li @click="setPosterPopup(item)" v-for="(item, i) in posterlist" :key="i">
        <!-- 图片 -->
        <div class="img">
          <img :src="address + item.img" alt />
        </div>
        <!-- 标题 -->
        <div class="title">{{item.content}}</div>
      </li>
    </ul>
    <!-- 分页 -->
    <div class="pagingList">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="queryInfo.size"
        :current-page="page"
        background
        layout="pager"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 海报弹窗 -->
    <div :class="posterPopup == false ? 'dp-n':''" class="posterPopup">
      <div class="posterPopupContent">
        <!-- 关闭 -->
        <div class="close" @click="closePosterPopup()">
          <img src="../../../assets/images/online/poster/close.png" alt />
        </div>
        <!-- 标题 -->
        <div class="title">{{posters.title}}</div>
        <!-- 描述 -->
        <div class="describe">{{posters.title}}</div>
        <ul class="posterList">
          <li v-for="(item, i) in posters. posterli" :key="i">
            <img :src="address + item" alt />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      posterPopup: false,
      // 查询参数对象
      queryInfo: {
        query: '',
        page: 0,
        size: 15,
        type: 10002,
        sort: 'sort,asc'
      },
      // 列表
      posterlist: {},
      // 总条数
      total: 0,
      page: 1,
      address: 'http://uploads.i-mineral.cn/',
      // 海报列表
      posters: {
        title: '',
        posterli: []
      }
    }
  },
  created() {
    this.getPosterList()
  },
  methods: {
    setPosterPopup(item) {
      // 设置标题
      this.posters.title = item.content
      this.posters.posterli = item.posterImgs.split(',')
      this.posterPopup = !this.posterPopup
    },
    closePosterPopup() {
      this.posterPopup = false
    },
    async getPosterList() {
      const { data: res } = await this.$http.get('/api/itemInfo', {
        params: this.queryInfo
      })
      if (res.content === null) {
        return this.$message.error('获取海报列表失败！')
      }
      this.posterlist = res.content
      this.total = res.totalElements
    },
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage - 1
      this.getPosterList()
      this.page = newPage
    }
  }
}
</script>

<style scoped>
@media screen and (min-width: 850px) {
  .posterContentList {
    width: 100%;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 849px) {
  .posterContentList {
    width: 100%;
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
  }
}

.posterContentList li {
  width: 200px;
  height: 190px;
  border: 1px solid rgb(220, 220, 220);
  margin: 10px;
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
}
.posterContentList li .img {
  width: 100%;
  height: 160px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
}
.posterContentList li .img img {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.posterContentList li .title {
  width: 100%;
  box-sizing: border-box;
  padding: 5px;
  position: absolute;
  font-size: 14px;
  bottom: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* 分页 */
.pagingList {
  width: 100%;
  max-width: 1100px;
  margin: 20px auto;
  display: flex;
  justify-content: center;
}
/* 海报弹窗 */
.posterPopup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
.posterPopupContent {
  width: 100%;
  max-width: 600px;
  height: 80%;
  margin: 90px auto;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
}
.posterPopupContent .close {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 10px;
  right: 10px;
}
.posterPopupContent .close img {
  width: 100%;
}
.posterPopupContent .title {
  width: 90%;
  box-sizing: border-box;
  padding: 20px 20px 10px 20px;
  font-size: 22px;
}
.posterPopupContent .describe {
  width: 90%;
  box-sizing: border-box;
  padding: 10px 20px;
  font-size: 18px;
  color: #999;
}
.posterPopupContent .posterList {
  width: 100%;
  height: 74%;
  position: absolute;
  right: -17px;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: scroll;
}
.posterPopupContent .posterList li {
  width: 98%;
  margin: 10px 0;
}
.posterPopupContent .posterList li img {
  width: 100%;
}
</style>
